/**
 * @format
 * @flow strict-local
 */
// INIT

const initialState = {
	address: {
		city: "",
		country: "",
		line1: "",
		line2: "",
		postalCode: "",
		state: ""
	},
	email: "",
	name: "",
	newCard: null,
	paymentMethod: "existing",
	plan: ""
};

// EXPORT

export default (state = initialState, action) => {
	switch(action.type) {
		case "RESET_ALL":
		case "RESET_SUBSCRIPTION":
		return initialState;
		case "SET_SUBSCRIPTION":
		return action.payload;
		case "UPDATE_SUBSCRIPTION":
		return {
			...state,
			...action.payload
		};
		default:
		return state;
	}
};
